// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"a163129c","141":"8afa21aa","157":"8c6c1974","178":"20387c2d","440":"846a6619","453":"75dabde4","491":"cb9ab91a","505":"38111384","732":"cde44a59","992":"9e6238bf"}[chunkId] + ".chunk.js";
};